module.exports = __webpack_public_path__ + "static/media/international-project.ccbd263e.png";